import './system-clock.scss';

import { TimeKeeper } from '@core/app/scripts/services/time-keeper';

/*
 * Component responsible for <system-clock>.
 */
angular
  .module('posApp')
  .directive(
    'systemClock',
    ($timeout: ng.ITimeoutService, timeKeeper: TimeKeeper) => ({
      restrict: 'E',

      scope: true,

      template: require('./system-clock.html').default,

      // TODO add unit test
      link: function ($scope, element, attrs) {
        let clockTimeout;

        $scope.localDate = timeKeeper.getLocalDate();

        function updateTime() {
          const timeout = 1000 * (61 - $scope.localDate.getSeconds());
          clockTimeout = $timeout(updateTime, timeout);
        }

        $scope.isShortDate = true;

        $scope.toggleDateFormat = function () {
          $scope.isShortDate = !$scope.isShortDate;
        };

        $scope.getDateFormat = function () {
          return $scope.isShortDate ? 'shortTime' : 'longDate';
        };

        updateTime();

        $scope.$on('$destroy', function () {
          $timeout.cancel(clockTimeout);
        });
      },
    }),
  );
